import { useState } from "react"
import Button from "../../../components/Button"
import colors from "../../../styles/colors"
import { typography } from "../../../styles/typography"
import { getDateString } from "../../../utils/Date"
import DropDown from "../../../icons/DropDown"
import DropUp from "../../../icons/DropUp"
import Footer from "../../../components/Footer"
import { useNavigate } from "react-router-dom"

const Inquiries = () => {
    const [inquiries, setInquiries] = useState([{
        title: "블루투스 연결이 잘 안돼요.",
        q: "제품 앞면 Led 판에 불빛이 반복적으로 깜빡거리면서 블루투스 연결이 되지 않습니다. ",
        a: "아이체크를 할 때마다 중간에 앱이 자꾸 꺼지는데 왜 그런가요. 눈운동만 하고 있는데, 아이체크를 못하고 있습니다. 앱을 깔았다 다시 깔아도 같은 현상이에요.",
        answerDate: new Date()
    },
    {
        title: "블루투스 연결이 잘 안돼요.",
        q: "제품 앞면 Led 판에 불빛이 반복적으로 깜빡거리면서 블루투스 연결이 되지 않습니다. ",
        date: new Date()
    },
    {
        title: "블루투스 연결이 잘 안돼요.",
        q: "제품 앞면 Led 판에 불빛이 반복적으로 깜빡거리면서 블루투스 연결이 되지 않습니다. ",
        a: "아이체크를 할 때마다 중간에 앱이 자꾸 꺼지는데 왜 그런가요. 눈운동만 하고 있는데, 아이체크를 못하고 있습니다. 앱을 깔았다 다시 깔아도 같은 현상이에요.",
        answerDate: new Date()
    },
    ])
    return (
        <div className={"scrollContainer"} style={style.scrollContainer}>
            <Button
                text={"문의 작성하기"}
                style={style.btn}
                onClick={()=> window.location.href = '/inquiry'}
            />
            {inquiries.map((value, i) => {
                return <Item item={value} key={i} />
            })}

            <Footer style={{ marginTop: 150 }} />
        </div>
    )
}

const Item = ({ item, index }) => {
    const navigate = useNavigate()
    function handleOpen() {
        navigate('/inquiry_answer',
            {
                state: item
            })
    }
    return <Button style={style.itemContainer} onClick={handleOpen}>
        <div style={style.top}>
            {item.a ? "답변 완료" : <span style={{ color: '#FF4E53' }}>미답변</span>}
            <span style={{ color: colors.mono300 }}>{" | " + getDateString(item.answerDate ?? item.date)}</span>
        </div>
        <div style={style.title}>{item.title}</div>
        <p style={style.item}> {item.q} </p>
    </Button>
}

const style = {
    scrollContainer: {
        alignItems: 'flex-start',
        overflowY: 'scroll',
        padding: '0px 0px'
    },
    btn: {
        ...typography.body["14_regular"],
        color: colors.white,
        height: 34,
        background: colors.primaryColor500,
        borderRadius: 10,
        padding: '6px 18px',
        alignSelf: 'flex-end',
        margin: '20px 16px 0px'
    },
    itemContainer: {
        width: '100%',
        borderBottom: `1px solid ${colors.surfaceBorderColor}`,
        padding: '24px 20px',
        flexDirection: 'column',
        borderRadius: 0,
        alignItems: 'flex-start'
    },
    item: {
        ...typography.body["14_regular"],
        color: colors.mono300,
        height: 60,
        width: '100%',
        justifyContent: 'space-between',
        textAlign: 'left',
        gap: 16
    },
    answer: {
        ...typography.body["14_regular"],
        color: colors.white,
        marginBottom: 24,
        textAlign: 'left',
        paddingLeft: 16,
        paddingTop: 16,
        borderTop: `1px solid ${colors.surfaceBorderColorMono}`
    },
    title: {
        ...typography.body["14_regular"],
        color: colors.white,
        marginTop: 16
    },
    top: {
        ...typography.caption_12_regular,
        color: '#3BC4FF'
    }
}

export default Inquiries